import React from 'react';
import { Home, FileSignature, FileText } from 'lucide-react';
import { ESAVE_PATH } from '../services/invoiceWhatsApp';

export default function ConsoleNavigation({ activeModule, salesEnabled, invoicesEnabled, onSelect }) {
    const items = [
        { id: 'home', label: 'Inicio', icon: Home },
        ...(salesEnabled ? [{ id: 'sales', label: 'Alta de contrato', icon: FileSignature }] : []),
    ];
    return <nav aria-label="Módulos de la consola"
        className="flex items-center gap-2 px-6 py-3 border-b border-slate-800 bg-slate-950/50 shrink-0 overflow-x-auto">
        {items.map(({ id, label, icon: Icon }) => <button key={id} type="button"
            onClick={() => onSelect(id)} aria-current={activeModule === id ? 'page' : undefined}
            aria-controls={`console-${id}`}
            className={`flex items-center gap-2 px-4 py-2 rounded-xl border whitespace-nowrap text-sm font-medium transition-colors ${activeModule === id
                ? 'border-primary/50 bg-primary/15 text-primary'
                : 'border-transparent text-slate-400 hover:text-slate-200 hover:bg-slate-800/50'}`}>
            <Icon size={18} />{label}
        </button>)}
        {invoicesEnabled && <a href={ESAVE_PATH} target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2 rounded-xl border border-transparent whitespace-nowrap text-sm font-medium text-slate-400 hover:text-slate-200 hover:bg-slate-800/50">
            <FileText size={18} />Facturas y simulación
        </a>}
    </nav>;
}
